
export class CoachTransition
{
    static AddGame = 1;
    static BuildBracket = 2;
    static RemoveGame = 3;
    static FinishTouches = 4;
    static Undo = 5;
    static Redo = 6;
    static PullChanges = 7;
    static DirtyGameFound = 8;
    static AllGamesLinked = 9;
    static NoGamesLinked = 10;
    static OneGameLinked = 11;
    static BrokenGameFound = 12;
    static LuckyNext = 13;
}